import React from 'react';
import StatusOval from '../components/StatusOval';

const svgStyle = {display: 'block', fontFamily: "'Geist', sans-serif", width: '100%', height: 'auto'};

const Avatar = ({cx, cy, r, fill, initials, fontSize, stroke = '#FFFFFF', strokeWidth = 2}) => (
    <>
        <circle cx={cx} cy={cy} r={r} fill={fill} stroke={stroke} strokeWidth={strokeWidth}/>
        <text x={cx} y={cy + fontSize * 0.35} fontSize={fontSize} fontWeight="600" fill="#FFFFFF" textAnchor="middle">
            {initials}
        </text>
    </>
);

export const VisualiseIllustrationDesktop = () => (
    <svg width="620" height="240" viewBox="0 0 620 240" aria-hidden="true" style={svgStyle}>
        <g stroke="#E1DED5" strokeWidth="2">
            <line x1="120" y1="20" x2="120" y2="224"/>
            <line x1="310" y1="20" x2="310" y2="224"/>
            <line x1="500" y1="20" x2="500" y2="224"/>
        </g>
        <g fill="none" stroke="#8A877E" strokeWidth="2">
            <path d="M180 60 C 240 60, 240 110, 252 110"/>
            <path d="M370 112 C 430 112, 430 160, 442 160"/>
            <path d="M310 136 L 310 176"/>
        </g>
        <StatusOval cx={120} cy={60} rx={60} ry={22} status="done" label="Done" fontSize={13}/>
        <StatusOval cx={310} cy={112} rx={60} ry={22} status="doing" label="Doing" fontSize={13}/>
        <StatusOval cx={500} cy={160} rx={60} ry={22} status="todo" label="To do" fontSize={13}/>
        <StatusOval cx={310} cy={198} rx={60} ry={22} status="todo" label="To do" fontSize={13}/>
    </svg>
);

export const VisualiseIllustrationMobile = () => (
    <svg width="326" height="200" viewBox="0 0 326 200" aria-hidden="true" style={svgStyle}>
        <g stroke="#E1DED5" strokeWidth="2">
            <line x1="60" y1="20" x2="60" y2="186"/>
            <line x1="163" y1="20" x2="163" y2="186"/>
            <line x1="266" y1="20" x2="266" y2="186"/>
        </g>
        <g fill="none" stroke="#8A877E" strokeWidth="2">
            <path d="M104 46 C 130 46, 128 98, 119 98"/>
            <path d="M207 98 C 233 98, 231 150, 222 150"/>
            <path d="M163 116 L 163 150"/>
        </g>
        <StatusOval cx={60} cy={46} rx={44} ry={18} status="done" label="Done" fontSize={12} strokeWidth={2.2}/>
        <StatusOval cx={163} cy={98} rx={44} ry={18} status="doing" label="Doing" fontSize={12} strokeWidth={2.2}/>
        <StatusOval cx={266} cy={150} rx={44} ry={18} status="todo" label="To do" fontSize={12} strokeWidth={2.2}/>
        <StatusOval cx={163} cy={168} rx={44} ry={18} status="todo" label="To do" fontSize={12} strokeWidth={2.2}/>
    </svg>
);

// Shared between desktop and mobile — same composition, CSS just scales the well.
export const ColourCodedIllustration = () => (
    <svg width="400" height="240" viewBox="0 0 400 240" aria-hidden="true" style={svgStyle}>
        <g fill="none" stroke="#8A877E" strokeWidth="2" strokeLinecap="round">
            <path d="M200 48 C 250 48, 268 62, 268 82"/>
            <path d="M262 76 L268 84 L274 76"/>
            <path d="M268 150 C 268 174, 250 190, 204 190"/>
            <path d="M212 184 L204 190 L212 196"/>
        </g>
        <StatusOval cx={130} cy={48} rx={70} ry={28} status="todo" label="To do" fontSize={15} strokeWidth={3}/>
        <StatusOval cx={270} cy={120} rx={70} ry={28} status="doing" label="Doing" fontSize={15} strokeWidth={3}/>
        <StatusOval cx={130} cy={190} rx={70} ry={28} status="done" label="Done" fontSize={15} strokeWidth={3}/>
    </svg>
);

export const CooperationIllustration = () => (
    <svg width="400" height="240" viewBox="0 0 400 240" aria-hidden="true" style={svgStyle}>
        <g fill="none" stroke="#A9A69C" strokeWidth="2" strokeDasharray="5 5">
            <path d="M160 64 C 220 64, 220 120, 232 120"/>
            <path d="M300 150 C 300 190, 250 190, 180 190"/>
        </g>
        <StatusOval cx={100} cy={64} rx={62} ry={24} status="done" label="Design" fontSize={14}/>
        <StatusOval cx={294} cy={122} rx={62} ry={24} status="doing" label="Build" fontSize={14}/>
        <StatusOval cx={120} cy={190} rx={62} ry={24} status="todo" label="Test" fontSize={14}/>
        <g fontSize="11" fontWeight="600" fill="#FFFFFF" textAnchor="middle">
            <Avatar cx={154} cy={40} r={15} fill="#6E56CF" initials="AK" fontSize={11} stroke="#F7F6F2" strokeWidth={3}/>
            <Avatar cx={348} cy={98} r={15} fill="#0D74CE" initials="JM" fontSize={11} stroke="#F7F6F2" strokeWidth={3}/>
            <Avatar cx={174} cy={166} r={15} fill="#C2410C" initials="SR" fontSize={11} stroke="#F7F6F2" strokeWidth={3}/>
        </g>
    </svg>
);

export const JiraIllustrationDesktop = () => (
    <svg width="620" height="240" viewBox="0 0 620 240" aria-hidden="true" style={svgStyle}>
        <text x="130" y="44" fontFamily="'Geist Mono', monospace" fontSize="12" letterSpacing="0.1em" fill="#8A887F"
              textAnchor="middle">OVALVIEW</text>
        <text x="470" y="44" fontFamily="'Geist Mono', monospace" fontSize="12" letterSpacing="0.1em" fill="#8A887F"
              textAnchor="middle">JIRA</text>
        <StatusOval cx={130} cy={130} rx={80} ry={30} status="doing" label="Doing" variant="dark" fontSize={15}/>
        <Avatar cx={200} cy={104} r={14} fill="#6E56CF" initials="AK" fontSize={10} stroke="#1E1E22" strokeWidth={3}/>
        <g fill="none" stroke="#6B6A72" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M240 120 H 360"/>
            <path d="M352 112 L360 120 L352 128"/>
            <path d="M360 142 H 240"/>
            <path d="M248 134 L240 142 L248 150"/>
        </g>
        <rect x="380" y="70" width="180" height="120" rx="14" fill="#26262B" stroke="#3A3A40"/>
        <text x="400" y="100" fontFamily="'Geist Mono', monospace" fontSize="12" fill="#8A887F">JRA-123</text>
        <text x="400" y="126" fontSize="15" fontWeight="600" fill="#FFFFFF">Payment flow</text>
        <rect x="400" y="146" width="104" height="26" rx="13" fill="#3A2E14"/>
        <circle cx="414" cy="159" r="4" fill="#F5A524"/>
        <text x="424" y="163" fontSize="12" fontWeight="600" fill="#FBC96B">In progress</text>
    </svg>
);

export const JiraIllustrationMobile = () => (
    <svg width="326" height="200" viewBox="0 0 326 200" aria-hidden="true" style={svgStyle}>
        <text x="72" y="40" fontFamily="'Geist Mono', monospace" fontSize="10" letterSpacing="0.1em" fill="#8A887F"
              textAnchor="middle">OVALVIEW</text>
        <text x="252" y="40" fontFamily="'Geist Mono', monospace" fontSize="10" letterSpacing="0.1em" fill="#8A887F"
              textAnchor="middle">JIRA</text>
        <StatusOval cx={72} cy={110} rx={54} ry={22} status="doing" label="Doing" variant="dark" fontSize={13} strokeWidth={2.2}/>
        <Avatar cx={118} cy={90} r={11} fill="#6E56CF" initials="AK" fontSize={8} stroke="#1E1E22" strokeWidth={3}/>
        <g fill="none" stroke="#6B6A72" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M136 102 H 176"/>
            <path d="M170 96 L176 102 L170 108"/>
            <path d="M176 120 H 136"/>
            <path d="M142 114 L136 120 L142 126"/>
        </g>
        <rect x="190" y="58" width="124" height="104" rx="12" fill="#26262B" stroke="#3A3A40"/>
        <text x="204" y="82" fontFamily="'Geist Mono', monospace" fontSize="10" fill="#8A887F">JRA-123</text>
        <text x="204" y="104" fontSize="13" fontWeight="600" fill="#FFFFFF">Payment flow</text>
        <rect x="204" y="120" width="92" height="24" rx="12" fill="#3A2E14"/>
        <circle cx="217" cy="132" r="4" fill="#F5A524"/>
        <text x="226" y="136" fontSize="11" fontWeight="600" fill="#FBC96B">In progress</text>
    </svg>
);
